import supabase from "./Supabase";
import { showToast } from "./Toasts";

export async function fetchPendingRequests () {
    const { data, error } = await supabase
        .from("requests")
        .select("*")
        .eq("request_deleted", false)
        .eq("added_to_database", false)
        .order("date_requested", { ascending: false });

    if (error) {
        showToast("error", `Unable to get pending requests: ${error.message}`);
    }
    return (data);
};

export async function fetchAddedRequests() {
    const { data, error } = await supabase
        .from("requests")
        .select("*, files(*)")
        .eq("request_deleted", false)
        .eq("added_to_database", true)
        .order("date_requested", { ascending: false });

    if (error) {
        showToast("error", `Unable to get added requests: ${error.message}`);
    }
    return (data);
};

export async function getUserRequests(user_id: string) {
    const { data, error } = await supabase
        .from("requests")
        .select(`*, files("Date Added")`)
        .eq("requested_id", user_id)
        .eq("request_deleted", false)
        .order("added_to_database", { ascending: false })
        .order("date_requested", { ascending: false });

    if (error) {
        showToast("error", `Unable to get user requests: ${error.message}`);
    }
    return (data);   
}

export async function getUserRequestCount(user_id: string) {
    const { count, error } = await supabase
        .from("requests")
        .select('*', {count: 'exact', head: true})
        .eq("requested_id", user_id)
        .eq("request_deleted", false)
        .eq("added_to_database", false);

    if (error) {
        showToast("error", `Unable to get count of user requests: ${error.message}`);
    }
    return (count || 0);   
}

export async function deleteRequest(row: any){    
    // This function performs a soft delete by setting request_deleted to true
    const { data, error } = await supabase
        .from("requests")
        .update({ request_deleted: true })
        .eq("id", row.id)
        .select();
    if (error || data.length === 0) {
        showToast("error", `Unable to delete request: ${error?.message || "record not found"}`);
    } else {
        showToast("info", "Request deleted!");
    }
}

export async function checkForDeletedRequests(title: string, writers: string) {
    const { data, error } = await supabase
        .from("requests")
        .select("*")
        .eq("request_deleted", true)
        .textSearch("script_title", title, { type: 'websearch' })
        .textSearch("writers", writers, { type: 'websearch' })
        .limit(1);

    if (data && data.length > 0) {
        return true;
    } else if (error) {
        showToast("error", `Unable to check for deleted requests: ${error.message}`);
        return true;
    }
    return false;
}

export async function setRequestAdded(id: number, database_id: string) {
    const { data, error } = await supabase
        .from("requests")
        .update({ added_to_database: true, database_id: database_id })
        .eq("id", id)
        .select();
    if (error || data.length === 0) {
        showToast("error", `Unable to mark request as added: ${error?.message || "record not found"}`);
        return false
    } else {
        showToast("success", "Request marked as added!");
        return true;
    }
}